import { Signal } from "@suse-o11y/signal";
import React from "react";

import { usePermanent } from "~/tools/use-permanent";

import { WidgetExpandContextProvider } from "./widget-context";

export const WidgetBoundary: React.FC<React.PropsWithChildren> = ({ children }) => {
	const value = usePermanent(() => Signal(new Map<string, boolean>()));

	return <WidgetExpandContextProvider value={value}>{children}</WidgetExpandContextProvider>;
};
